export const findBlocksWithKeyValue = (projectStructure, key, value) => {
    let result = []

    for (const page of projectStructure.pages) {
        const blocks = page.blocks.filter(block => block[key] === value)
        result = [...result, ...blocks]
    }

    return result
}
